import React from "react";
import { CheckboxButton, colors2 } from "oolib";
import { ButtonGhost, ButtonPrimary } from "oolib/dist/v2/components/Buttons";

const TableToggleButton = ({ value, onChange, id, disabled, visible = true }) => {
  
   const onClickHandler = () => {
    const newVal = value === true ? false : true;

    onChange(id, newVal);
  };

  if(!visible) return null;

  return (
    <div
      style={{width: '100%', display: 'flex', justifyContent: 'center'}}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      {value === true ? (
        <ButtonPrimary
          disabled={disabled}
          icon="Sparkle"
          style={{ backgroundColor: colors2.purple, padding: "4px" }}
          onClick={onClickHandler}
        />
      ) : (
        <ButtonGhost
          disabled={disabled}
          icon="Sparkle"
          iconColor={colors2.purple}
          style={{ padding: "4px" }}
          onClick={onClickHandler}
        />
      )}
    </div>
  );
};

export default TableToggleButton;
